import type { User, UserPermissionType } from '../store/services/AuthService/types';

export const hasSufficientPermissions = (user: User | undefined, requiredPermissionType: UserPermissionType) => {
  if (!user) {
    return false;
  }
  if (!requiredPermissionType) {
    return true;
  }

  if (requiredPermissionType === 'viewer' || user.sessionPartnerRole === 'administrator') {
    return true;
  } else if (requiredPermissionType === user.sessionPartnerRole) {
    return true;
  } else {
    return false;
  }
};

export const removeTrailingSlash = (linkString: string) => {
  return linkString?.endsWith('/') ? linkString.slice(0, -1) : linkString;
};
